import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { KoncentroValidators } from '../../../../modules/UIKit/validators/koncentro-validators';
import { CustomerCardService } from '../../../../services/customer/customer-card.service';
import { AuthService } from '../../../../services/user/auth.service';
import { FormValidationService } from '../../../../services/utils/form-validation.service';

@Component({
  selector: 'app-create-customer-store-ext',
  templateUrl: './create-customer-store-ext.component.html',
  styleUrls: ['./create-customer-store-ext.component.css']
})
export class CreateCustomerStoreExtComponent implements OnInit {

  pageTitle = 'Attivazione Carta';
  formData: FormGroup;

  public maxDate: Date = new Date();


  constructor (
    private fb: FormBuilder,
    private translate: TranslateService,
    private customerCardService: CustomerCardService,
    private authService: AuthService,
    private srvValidation: FormValidationService,
    private srvNotify: MessageService
  ) { }

  resetForm() {
    let group: object = {
      cardNo: ['', [Validators.required, Validators.maxLength(13)]],
      surname: ['', [Validators.required, Validators.maxLength(255)]],
      name: ['', [Validators.required, Validators.maxLength(255)]],
      birthDate: ['', KoncentroValidators.dateNotAfter(this.maxDate)],
      privacyTerminal: { value: false, disabled: true },
      privacyGenericComm: { value: false, disabled: true },
      privacyMktgResearch: { value: false, disabled: true },
      privacyAuth: [{ value: true, disabled: true }, Validators.requiredTrue],
      privacyMktgProfiling: { value: false, disabled: false },
      privacyMktgActivity: { value: false, disabled: false },
      privacyPurchaseCom: { value: false, disabled: true },
      privacyOptin: { value: false, disabled: true },
      sourceCode: 'CCN',
      companyCode: this.authService.user.selectedCompany
    };

    this.formData = null;
    this.formData = this.fb.group(group);
  }

  ngOnInit() {
    this.resetForm();
    this.maxDate.setFullYear(this.maxDate.getFullYear() - 18);
  }

  save() {
    if (!this.formData.valid) {
      console.log('errors', this.formData);

      this.srvValidation.validateAllFormFields(this.formData);

      return false;
    }

    console.log('form data raw value', this.formData.getRawValue());
    const customerData = this.formData.getRawValue();

    customerData.privacyTerminal = customerData.privacyTerminal ? '1' : '0';
    customerData.privacyGenericComm = customerData.privacyGenericComm ? '1' : '0';
    customerData.privacyMktgResearch = customerData.privacyMktgResearch ? '1' : '0';
    customerData.privacyAuth = customerData.privacyAuth ? '1' : '0';
    customerData.privacyMktgProfiling = customerData.privacyMktgProfiling ? '1' : '0';
    customerData.privacyMktgActivity = customerData.privacyMktgActivity ? '1' : '0';
    customerData.privacyPurchaseCom = customerData.privacyPurchaseCom ? '1' : '0';
    customerData.privacyOptin = customerData.privacyOptin ? '1' : '0';
    customerData.birthDate = customerData.birthDate === '' ? null : customerData.birthDate;

    this.customerCardService.createCustomerStore(customerData).subscribe(res => {
      const detail = 'Cliente e Carta creati e associati.' + (res.hostId ? (' Customer Code: ' + res.hostId) : '');

      this.srvNotify.add({severity: 'success', summary: 'Success', detail: detail});

      this.resetForm();
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/views/customerDB/customer-ext/create-customer-store-ext/create-customer-store-ext.component.ts